import { boolPropsToClassNames } from 'common/utils/style.utils';
import { StyledCategoryItem } from './CategoriesList.style';
import MultiLinesChart from 'components/MultiLinesChart';
import Icon from 'components/base/Icon';
import { CATEGORIES_KEYS } from '../useCategoriesWidget/useCategoriesWidget';
import useInvestmentCarvingIssuesDisplayEnabled from '../../feature-flags/useInvestmentCarvingIssuesDisplayEnabled';

const CategoryItem = ({ category, isSelected, innerText, onClick }) => {
  const issuesDisplayEnabled = useInvestmentCarvingIssuesDisplayEnabled();
  const linesData = [
    { value: category.fte_p, color: category.color },
    { value: category.benchmark, ...(innerText && { innerText }) }
  ];

  const isClickable =
    issuesDisplayEnabled || category.key !== CATEGORIES_KEYS.OTHERS;

  return (
    <StyledCategoryItem
      className={boolPropsToClassNames({ isSelected, isClickable })}
      onClick={() => isClickable && onClick(category)}
    >
      <main>
        <header>{category.name}</header>
        <MultiLinesChart lines={linesData} />
      </main>
      <aside>
        {isSelected && <Icon name='ChevronRight' color='pigeonPost' />}
      </aside>
    </StyledCategoryItem>
  );
};

export default CategoryItem;
